import { usePersistedState } from "./usePersistedState";

/** localStorage-backed state with a JSON-aware codec; SSR- and quota-safe. */
export function useLocalStorage<T>(
  key: string,
  initialValue: T,
  codec: {
    parse?: (raw: string) => T;
    stringify?: (value: T) => string;
  } = {},
): [T, (value: T | ((prev: T) => T)) => void] {
  return usePersistedState<T>(key, initialValue, {
    storage: "local",
    parse: codec.parse,
    stringify: codec.stringify,
  });
}
